/**
 * Enum com os perfis de usuário do sistema EdducaImob.
 * Os IDs correspondem aos valores do banco de dados e do JWT (claim: perfilId).
 */
export enum PerfilEnum {
  ADM_SISTEMA = 1,
  ADM_IMOBILIARIA = 2,
  USUARIO_IMOBILIARIA = 3,
  PARCEIRO = 4,
  ADM_PARCERIA = 5
}

/**
 * Nomes dos perfis para exibição
 */
export const PerfilNomes: { [key in PerfilEnum]: string } = {
  [PerfilEnum.ADM_SISTEMA]: 'Administrador do Sistema',
  [PerfilEnum.ADM_IMOBILIARIA]: 'Administrador da Imobiliária',
  [PerfilEnum.USUARIO_IMOBILIARIA]: 'Usuário da Imobiliária',
  [PerfilEnum.PARCEIRO]: 'Parceiro',
  [PerfilEnum.ADM_PARCERIA]: 'Administrador de Parceria'
};
